import { useEffect } from "react";
import { useState } from "react";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";

const FormDetail = ({ formDetails, translate }) => {
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    setViewData([
      {
        name: translate("form_templates.uppercase_translates.template_state"),
        value: formDetails?.status?.value
          ? translate(formDetails.status.value)
          : "",
        class: `text-uppercase${
          formDetails?.status?.label
            ? ` col-status--` + formDetails.status.value
            : ""
        }`,
      },
      {
        name: translate("form_templates.uppercase_translates.created_at"),
        value: timeStampToDateFormat(formDetails.created_at),
      },
      {
        name: translate("form_templates.uppercase_translates.version"),
        value: formDetails?.version,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.created_by"
        ),
        value: formDetails?.created_by,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.id_number"
        ),
        value: formDetails?.id_number,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.updated_at"
        ),
        value: timeStampToDateFormat(formDetails.modified_at),
      },
      {
        name: translate("form_templates.uppercase_translates.form_name"),
        value: formDetails?.name,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.updated_by"
        ),
        value: formDetails?.modified_by,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.location_set"
        ),
        value: formDetails?.site_set?.label,
        class: "text-blue text-uppercase",
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.location_set_level"
        ),
        value: formDetails?.site_set_level?.label,
        class: "text-blue text-uppercase",
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.status_set"
        ),
        value: formDetails?.status_set?.label,
        class: "text-blue",
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.revision_set"
        ),
        value: formDetails?.revision_set?.label,
        class: "text-blue",
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.prefix"
        ),
        value: formDetails?.prefix,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.counter_format"
        ),
        value: formDetails?.counter_format,
      },
      {
        name: translate(
          "form_templates.uppercase_translates.general_info.quick_start"
        ),
        value: formDetails?.quick_start?.label,
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDetails]);

  return (
    <div className="container">
      <div className="row bg-white ps-0 ps-md-3 py-4 mt-3">
        {viewData.map((item, index) => (
          <div className="col-12 col-md-5 mb-3" key={index}>
            <p className="text-uppercase mb-0">{item.name}</p>
            <div className="w-100">
              <p className={`fw-bold mt-2 ${item.class ? item.class : ""}`}>
                {item.value || ""}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default FormDetail;
